import { render, staticRenderFns } from "./VipLevels.vue?vue&type=template&id=07009416&scoped=true&"
import script from "./VipLevels.vue?vue&type=script&lang=js&"
export * from "./VipLevels.vue?vue&type=script&lang=js&"
import style0 from "./VipLevels.vue?vue&type=style&index=0&id=07009416&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07009416",
  null
  
)

export default component.exports